import carousel1 from "../../../assets/carousel/carousel1.jpg";
import carousel2 from "../../../assets/carousel/carousel2.jpg";
import carousel3 from "../../../assets/carousel/carousel3.jpg";
import carousel4 from "../../../assets/carousel/carousel4.jpg";
import carousel5 from "../../../assets/carousel/carousel5.jpg";
import carousel6 from "../../../assets/carousel/carousel6.jpg";

const mock = {
  images1: [
    {
      label: "Bali, Indonesia",
      image: carousel1,
    },
    {
      label: "San Francisco – Oakland Bay Bridge, United States",
      image: carousel2,
    },
    {
      label: "Brooklyn Bridge - New York, United States",
      image: carousel3,
    },
    {
      label: "Canary Islands, Spain",
      image: carousel4,
    },
    {
      label: "Alaska - Glacier Bay National Park, United States",
      image: carousel5,
    },
    {
      label: "Puget Sound - Seattle, United States",
      image: carousel6,
    },
  ],
  images2: [
    {
      label: "San Francisco – Oakland Bay Bridge, United States",
      image: carousel2,
    },
    {
      label: "Alaska - Glacier Bay National Park, United States",
      image: carousel3,
    },
    {
      label: "Canary Islands, Spain",
      image: carousel4,
    },
    {
      label: "Alaska - Glacier Bay National Park, United States",
      image: carousel5,
    },
    {
      label: "Puget Sound - Seattle, United States",
      image: carousel6,
    },
    {
      label: "Bali, Indonesia",
      image: carousel1,
    },
  ],
  images3: [
    {
      label: "Alaska - Glacier Bay National Park, United States",
      image: carousel3,
    },
    {
      label: "Canary Islands, Spain",
      image: carousel4,
    },
    {
      label: "Alaska - Glacier Bay National Park, United States",
      image: carousel5,
    },
    {
      label: "Puget Sound - Seattle, United States",
      image: carousel6,
    },
    {
      label: "Bali, Indonesia",
      image: carousel1,
    },
    {
      label: "San Francisco – Oakland Bay Bridge, United States",
      image: carousel2,
    },
  ],
};

export default mock;
